export const getEmailDomain = (email: string): string => {
  const atIndex = email.indexOf("@");
  if (atIndex === -1) return "";
  return email.slice(atIndex + 1).toLowerCase();
};

export const isCrossDomain = (emailA: string, emailB: string): boolean => {
  if (!emailA || !emailB) return false;
  const domainA = getEmailDomain(emailA);
  const domainB = getEmailDomain(emailB);
  if (!domainA || !domainB) return false;
  return domainA !== domainB;
};
